export default "__VITE_ASSET__edbebc07__"